import React, { useState } from "react";
import { isMobile } from 'lib/checkuseros';

import { listOfDevices } from "./config";

import DesktopMp4 from "./assets/desktop-phone-format-2.mp4";
import DesktopWebM from "./assets/desktop-phone-format-1.webm";
import MobileWebM from "./assets/mobile-phone-format-1.webm";
import MobileMp4 from "./assets/mobile-phone-format-2.mp4";

import Button from "../button";

import WithIntersectionObserver from "../../../../hocs/WithIntersectionObserver/WithIntersectionObserver";
import LottieAnimation from "../ui/lottie-animation/LottiAnimation";

const AnimatedLottie = WithIntersectionObserver(LottieAnimation);

import "./styles.less";

import { translate } from "react-polyglot";
import QrPopup from "../ui/qr-popup";


const BlockDevices = ({ t, registrationRedirectionURL }) => {
  const [isPopupOpened, setIsPopupOpened] = useState(false);
  const isMobileOS = isMobile()

  const handleRegistrationClick = () => {
    window.location.assign(registrationRedirectionURL);
  };


  const handleActionButtonClick = () => {
    if (isMobileOS) {
      window.location.assign(`${window.location.origin}/redirects/checkos_redirect.html`);
      return;
    }

    setIsPopupOpened(true);
  };

  return (
    <div className="block-devices__container">
      {
        isPopupOpened &&
        <QrPopup
          closePopup={() => setIsPopupOpened(false)}
          actionButtonClick={handleRegistrationClick}
        />
      }
      <div className="block-devices__inner-wrapper">
        <div className="block-devices__section-1">
          <p className="block-devices__title">{t("landing.block-devices.title")}</p>
          <p className="block-devices__description">
            {t("landing.block-devices.subtitle")}
          </p>

          <div className="block-devices__items">
            {listOfDevices.map(({ name, translationKey, animationData, animationSize }) => (
              <div key={name} className="block-devices__item">
                <AnimatedLottie
                  width={animationSize.width}
                  height={animationSize.height}
                  animationData={animationData}
                  autoPlay={false}
                />
                <p className="block-devices__item-text">{t(translationKey)}</p>
              </div>
            ))}
          </div>

          <div className="block-devices__section-2--mob">
            <video
              loop
              muted
              autoPlay
              controls={false}
              playsInline
              preload="auto"
              className="block-devices__media"
            >
              <source src={MobileMp4} type="video/mp4" />
              <source src={MobileWebM} type="video/webm" />
            </video>
          </div>
          <div className="block-devices__action">
            <p className="block-devices__action-text">{t("landing.block-devices.actionText")}</p>
            <Button
              handleClick={handleActionButtonClick}
              isStore
              text={t("landing.block-devices.button")}
              size="lg"
              variant="filled" />
          </div>
        </div>
        <div className="block-devices__section-2">
          <video autoPlay muted loop className="block-devices__media">
            <source src={DesktopMp4} type="video/mp4" />
            <source src={DesktopWebM} type="video/webm" />
          </video>
        </div>
      </div>
    </div>
  );
};

export default translate()(BlockDevices);



// WEBPACK FOOTER //
// ./src/js/components/pages/newLandingPage/block-devices/index.js